/**
 * NADAN DELIGHTS - THEME JAVASCRIPT
 */

document.addEventListener('DOMContentLoaded', () => {
  initStickyHeader();
  initMobileMenu();
  initCartDrawer();
  initProductTabs();
  initProductGallery();
  initVariantSwatches();
  initQtySelectors();
  initStickyAddToCart();
  initRecentlyViewed();
  initCookieConsent();
  initFAQAccordion();
  initTextScramble();
  initSearchWildcard();
});

/* ==========================================================================
   1. Sticky Header
   ========================================================================== */
function initStickyHeader() {
  const header = document.querySelector('.site-header');
  if (!header) return;

  const stickyClass = 'site-header--sticky';
  const stickyTrigger = 100;

  window.addEventListener('scroll', () => {
    if (window.scrollY > stickyTrigger) {
      header.classList.add(stickyClass);
    } else {
      header.classList.remove(stickyClass);
    }
  });
}

/* ==========================================================================
   2. Mobile Menu
   ========================================================================== */
function initMobileMenu() {
  const toggle = document.querySelector('.mobile-nav-toggle');
  const drawer = document.querySelector('.mobile-menu-drawer');
  const closeBtn = document.querySelector('.mobile-menu-close');

  if (!toggle || !drawer) return;

  // Create overlay if not present
  let overlay = document.querySelector('.mobile-menu-overlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.className = 'cart-drawer-overlay mobile-menu-overlay';
    document.body.appendChild(overlay);
  }

  toggle.addEventListener('click', () => {
    drawer.classList.add('active');
    overlay.classList.add('active');
  });

  const closeMenu = () => {
    drawer.classList.remove('active');
    overlay.classList.remove('active');
  };

  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  overlay.addEventListener('click', closeMenu);
}

/* ==========================================================================
   3. AJAX Cart Drawer
   ========================================================================== */
function initCartDrawer() {
  const cartButtons = document.querySelectorAll('.js-open-cart-drawer');
  const drawer = document.querySelector('.cart-drawer');
  const overlay = document.querySelector('.cart-drawer-overlay');
  const closeBtn = document.querySelector('.cart-drawer-close');

  if (!drawer || !overlay) return;

  // Helper to open drawer
  window.openCartDrawer = () => {
    drawer.classList.add('active');
    overlay.classList.add('active');
    fetchAndRenderCart();
  };

  // Helper to close drawer
  window.closeCartDrawer = () => {
    drawer.classList.remove('active');
    overlay.classList.remove('active');
  };

  cartButtons.forEach(btn => btn.addEventListener('click', (e) => {
    e.preventDefault();
    window.openCartDrawer();
  }));

  if (closeBtn) closeBtn.addEventListener('click', window.closeCartDrawer);
  overlay.addEventListener('click', window.closeCartDrawer);

  // Monitor form submissions for Add To Cart
  document.body.addEventListener('submit', (e) => {
    const form = e.target;
    if (form.action && form.action.includes('/cart/add')) {
      e.preventDefault();
      addToCartAJAX(form);
    }
  });
}

// Add item to Shopify cart via Fetch API
async function addToCartAJAX(form) {
  if (window.themeSettings && window.themeSettings.disablePurchaseActions) {
    const idInput = form.querySelector('input[name="id"]');
    const id = idInput ? idInput.value : '';
    const titleElem = document.querySelector('h1, .product-title');
    const title = titleElem ? titleElem.innerText.trim() : 'Kerala Snack Product';
    if (window.trackAndShowOutOfStock) {
      window.trackAndShowOutOfStock('add_to_cart', id, title);
    }
    return;
  }
  const submitBtn = form.querySelector('[type="submit"]');
  const originalText = submitBtn ? submitBtn.innerText : 'Add to Cart';

  if (submitBtn) {
    submitBtn.disabled = true;
    submitBtn.innerText = 'Adding...';
  }

  const formData = new FormData(form);

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    });

    if (response.ok) {
      if (submitBtn) {
        submitBtn.innerText = 'Added!';
        setTimeout(() => {
          submitBtn.innerText = originalText;
          submitBtn.disabled = false;
        }, 1500);
      }
      window.openCartDrawer();
    } else {
      console.error('Failed to add to cart');
      if (submitBtn) {
        submitBtn.innerText = 'Error adding';
        submitBtn.disabled = false;
      }
    }
  } catch (error) {
    console.error('Error adding item to cart:', error);
    if (submitBtn) {
      submitBtn.disabled = false;
    }
  }
}

// Fetch Shopify cart object and update Drawer HTML
async function fetchAndRenderCart() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    
    // Update cart counts
    updateCartCountBadges(cart.item_count);

    const itemsContainer = document.querySelector('.cart-drawer-items');
    const subtotalContainer = document.querySelector('.js-cart-subtotal');

    if (!itemsContainer) return;

    if (cart.item_count === 0) {
      itemsContainer.innerHTML = `<p class="text-center" style="margin: auto; color: var(--color-text-muted);">${window.themeLocale?.cartEmpty || 'Your basket is empty. Add some Kerala snacks to start!'}</p>`;
      if (subtotalContainer) subtotalContainer.innerText = formatMoney(0);
      return;
    }

    let itemsHTML = '';
    cart.items.forEach(item => {
      itemsHTML += `
        <div class="drawer-cart-item" data-id="${item.key}">
          <img src="${item.image || 'https://via.placeholder.com/80'}" class="drawer-cart-item-img" alt="${item.title}">
          <div class="drawer-cart-item-info">
            <h4>${item.product_title}</h4>
            ${item.variant_title ? `<div class="drawer-cart-item-variant">${item.variant_title}</div>` : ''}
            <div class="drawer-cart-item-qty">
              <button onclick="updateQty('${item.key}', ${item.quantity - 1})">-</button>
              <input type="text" value="${item.quantity}" readonly>
              <button onclick="updateQty('${item.key}', ${item.quantity + 1})">+</button>
            </div>
          </div>
          <div class="drawer-cart-item-price">
            <span>${formatMoney(item.final_line_price)}</span>
            <button class="drawer-cart-item-remove" onclick="updateQty('${item.key}', 0)">Remove</button>
          </div>
        </div>
      `;
    });

    itemsContainer.innerHTML = itemsHTML;
    if (subtotalContainer) subtotalContainer.innerText = formatMoney(cart.total_price);

  } catch (error) {
    console.error('Error rendering cart:', error);
  }
}

// Update quantities in Shopify cart via JSON API
async function updateQty(itemKey, qty) {
  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: qty
      })
    });

    if (response.ok) {
      fetchAndRenderCart();
    }
  } catch (error) {
    console.error('Error changing cart quantity:', error);
  }
}

// Expose updateQty globally for inline onclick execution
window.updateQty = updateQty;

function updateCartCountBadges(count) {
  const badges = document.querySelectorAll('.cart-count-badge');
  badges.forEach(badge => {
    badge.innerText = count;
    badge.style.display = count > 0 ? 'flex' : 'none';
  });
}

function formatMoney(cents) {
  // Simplistic currency formatter - default is INR
  const format = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0
  });
  return format.format(cents / 100);
}

// Exposed global helper to quick add an item (from collections / search)
window.quickAddProduct = async function(variantId, quantity = 1, title = '') {
  try {
    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push({
        event: 'add_to_cart',
        product_id: String(variantId),
        product_name: title || 'Kerala Snack Item',
        page_location: window.location.href
      });
    }
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'AddToCart', {
        content_name: title || 'Kerala Snack Item',
        content_ids: [String(variantId)],
        content_type: 'product'
      });
    }
  } catch (e) {
    console.error('Analytics tracking error:', e);
  }

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity
      })
    });
    if (response.ok) {
      if (window.openCartDrawer) {
        window.openCartDrawer();
      } else {
        window.location.href = '/cart';
      }
    } else {
      window.location.href = '/cart';
    }
  } catch (error) {
    console.error('Quick add failed:', error);
    window.location.href = '/cart';
  }
};

window.buyNowProduct = async function(variantId, quantity = 1, title = 'kerala-banana-chips', weight = '500 g') {
  try {
    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push({
        event: 'begin_checkout',
        product_id: String(variantId),
        product_name: title || 'Kerala Snack Item',
        page_location: window.location.href
      });
    }
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'InitiateCheckout', {
        content_name: title || 'Kerala Snack Item',
        content_ids: [String(variantId)],
        content_type: 'product'
      });
    }
  } catch (e) {
    console.error('Analytics tracking error:', e);
  }

  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity
      })
    });
    window.location.href = '/checkout';
  } catch (error) {
    console.error('Buy Now failed:', error);
    window.location.href = '/checkout';
  }
};

/* ==========================================================================
   4. Variant Swatches
   ========================================================================== */
function initVariantSwatches() {
  const swatchOptions = document.querySelectorAll('.js-swatch-option');
  if (swatchOptions.length === 0) return;

  swatchOptions.forEach(swatch => {
    swatch.addEventListener('click', function() {
      const parent = this.closest('.swatch-options');
      const selectedValue = this.getAttribute('data-value');
      
      // Update UI active state
      parent.querySelectorAll('.js-swatch-option').forEach(btn => btn.classList.remove('active'));
      this.classList.add('active');

      // Update underlying hidden dropdown for variant values
      const variantOptionIndex = parent.getAttribute('data-option-index');
      const productForm = this.closest('form');
      if (!productForm) return;

      const hiddenSelect = productForm.querySelector(`.single-option-selector[data-index="${variantOptionIndex}"]`);
      if (hiddenSelect) {
        hiddenSelect.value = selectedValue;
        hiddenSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });

  // Track changes on single option selectors to map to main variant ID
  const singleOptionSelectors = document.querySelectorAll('.single-option-selector');
  singleOptionSelectors.forEach(select => {
    select.addEventListener('change', function() {
      const productForm = this.closest('form');
      if (!productForm) return;

      const variantsJsonAttr = productForm.querySelector('[data-variants-json]');
      if (!variantsJsonAttr) return;

      const variants = JSON.parse(variantsJsonAttr.innerHTML);
      
      // Collect current selections
      const currentSelections = [];
      productForm.querySelectorAll('.single-option-selector').forEach(sel => {
        currentSelections.push(sel.value);
      });

      // Find matching variant
      const matchedVariant = variants.find(variant => {
        return variant.options.every((option, index) => option === currentSelections[index]);
      });

      const mainVariantInput = productForm.querySelector('input[name="id"]');
      const priceText = document.querySelector('.js-product-price');
      const compareText = document.querySelector('.js-product-compare-price');
      const submitBtn = productForm.querySelector('[type="submit"]');

      if (matchedVariant) {
        if (mainVariantInput) mainVariantInput.value = matchedVariant.id;
        
        // Update Price Display
        if (priceText) priceText.innerText = formatMoney(matchedVariant.price);
        if (compareText) {
          if (matchedVariant.compare_at_price > matchedVariant.price) {
            compareText.innerText = formatMoney(matchedVariant.compare_at_price);
            compareText.style.display = 'inline';
          } else {
            compareText.style.display = 'none';
          }
        }

        // Update Add to Cart Button state
        if (submitBtn) {
          if (matchedVariant.available) {
            submitBtn.disabled = false;
            submitBtn.innerText = 'Add to Cart';
          } else {
            submitBtn.disabled = true;
            submitBtn.innerText = 'Out of Stock';
          }
        }

        // Update sticky add to cart bar if active
        const stickyPrice = document.querySelector('.sticky-atc-price');
        if (stickyPrice) stickyPrice.innerText = formatMoney(matchedVariant.price);

        // Update WhatsApp CTA buttons if active
        const enquiryBtnMain = document.getElementById('WhatsAppEnquiryBtnMain');
        const orderBtnMain = document.getElementById('WhatsAppOrderBtnMain');
        if (enquiryBtnMain || orderBtnMain) {
          const checkBtn = enquiryBtnMain || orderBtnMain;
          const match = checkBtn.href.match(/wa\.me\/([0-9]+)/);
          if (match) {
            const waNumber = match[1];
            const prodTitle = document.querySelector('.product-title')?.innerText || "";
            if (enquiryBtnMain) {
              const msg = `Hi Mallu Snacks! I'd like to enquire about ${prodTitle} (${matchedVariant.title}).`;
              enquiryBtnMain.href = `https://wa.me/${waNumber}?text=${encodeURIComponent(msg)}`;
            }
            if (orderBtnMain) {
              const msg = `Hi Mallu Snacks! I'd like to order ${prodTitle} (${matchedVariant.title}) for ${formatMoney(matchedVariant.price)}.`;
              orderBtnMain.href = `https://wa.me/${waNumber}?text=${encodeURIComponent(msg)}`;
            }
          }
        }

      } else {
        // Variant combination not available
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.innerText = 'Unavailable';
        }
      }
    });
  });
}

/* ==========================================================================
   5. Product Image Gallery & Zoom
   ========================================================================== */
function initProductGallery() {
  const mainImg = document.querySelector('.gallery-main-img');
  const mainWrapper = document.querySelector('.gallery-main-img-wrapper');
  const thumbnails = document.querySelectorAll('.gallery-thumbnail');

  if (!mainImg || !mainWrapper) return;

  // Toggle zoomed class on click
  mainWrapper.addEventListener('click', function() {
    mainImg.classList.toggle('zoomed');
  });

  // Track mouse coordinates for magnifier zoom
  mainWrapper.addEventListener('mousemove', function(e) {
    if (!mainImg.classList.contains('zoomed')) return;
    const rect = mainWrapper.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    
    const xPercent = (x / rect.width) * 100;
    const yPercent = (y / rect.height) * 100;

    mainImg.style.transformOrigin = `${xPercent}% ${yPercent}%`;
  });

  mainWrapper.addEventListener('mouseleave', function() {
    mainImg.classList.remove('zoomed');
    mainImg.style.transformOrigin = 'center center';
  });

  // Switch images via thumbnails
  thumbnails.forEach(thumb => {
    thumb.addEventListener('click', function() {
      thumbnails.forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      mainImg.src = this.getAttribute('data-image-src');
    });
  });
}

/* ==========================================================================
   6. Quantity Selectors
   ========================================================================== */
function initQtySelectors() {
  const qtySelectors = document.querySelectorAll('.qty-selector');
  qtySelectors.forEach(selector => {
    const minus = selector.querySelector('.qty-minus');
    const plus = selector.querySelector('.qty-plus');
    const input = selector.querySelector('.qty-input');

    if (!minus || !plus || !input) return;

    minus.addEventListener('click', () => {
      let val = parseInt(input.value) || 1;
      if (val > 1) {
        input.value = val - 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    plus.addEventListener('click', () => {
      let val = parseInt(input.value) || 1;
      input.value = val + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
}

/* ==========================================================================
   7. Product Tabs
   ========================================================================== */
function initProductTabs() {
  const tabHeaders = document.querySelectorAll('.js-tab-header');
  tabHeaders.forEach(header => {
    header.addEventListener('click', function() {
      const parent = this.closest('.product-tabs');
      const tabTarget = this.getAttribute('data-tab');

      // Deactivate other tabs
      parent.querySelectorAll('.js-tab-header').forEach(h => h.classList.remove('active'));
      parent.querySelectorAll('.tab-content-panel').forEach(p => p.classList.remove('active'));

      // Activate clicked tab
      this.classList.add('active');
      const matchingPanel = parent.querySelector(`.tab-content-panel[data-tab-content="${tabTarget}"]`);
      if (matchingPanel) matchingPanel.classList.add('active');
    });
  });
}

/* ==========================================================================
   8. Sticky Add to Cart
   ========================================================================== */
function initStickyAddToCart() {
  const stickyBar = document.querySelector('.sticky-atc-bar');
  const mainBuyBtn = document.querySelector('.add-to-cart-btn');

  if (!stickyBar || !mainBuyBtn) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) {
        stickyBar.classList.add('active');
      } else {
        stickyBar.classList.remove('active');
      }
    });
  }, {
    rootMargin: '100px 0px 0px 0px' // Trigger slightly before scrolling past the main buy button
  });

  observer.observe(mainBuyBtn);
}

/* ==========================================================================
   9. Recently Viewed Products
   ========================================================================== */
function initRecentlyViewed() {
  const container = document.querySelector('.js-recently-viewed-products');
  const activeProduct = document.querySelector('[data-active-product-handle]');

  // Log active product view
  if (activeProduct) {
    const handle = activeProduct.getAttribute('data-active-product-handle');
    let views = JSON.parse(localStorage.getItem('recently_viewed_snacks') || '[]');
    
    // Remove if already exists, then push to start
    views = views.filter(v => v !== handle);
    views.unshift(handle);

    // Limit to 4 products
    views = views.slice(0, 4);
    localStorage.setItem('recently_viewed_snacks', JSON.stringify(views));
  }

  // Render recently viewed
  if (container) {
    renderRecentlyViewed(container);
  }
}

async function renderRecentlyViewed(container) {
  const views = JSON.parse(localStorage.getItem('recently_viewed_snacks') || '[]');
  const activeProduct = document.querySelector('[data-active-product-handle]');
  const activeHandle = activeProduct ? activeProduct.getAttribute('data-active-product-handle') : null;

  // Filter out current product
  const renderHandles = views.filter(v => v !== activeHandle).slice(0, 4);

  if (renderHandles.length === 0) {
    container.closest('section').style.display = 'none';
    return;
  }

  let productCardsHTML = '';
  for (const handle of renderHandles) {
    try {
      const response = await fetch(`/products/${handle}.js`);
      if (response.ok) {
        const product = await response.json();
        
        let imgSrc = product.featured_image || 'https://via.placeholder.com/280';
        if (!product.featured_image && window.themeAssets) {
          imgSrc = window.themeAssets.productSaltedChips || 'https://via.placeholder.com/280';
        }

        productCardsHTML += `
          <div class="product-card">
            <a href="${product.url}" class="product-card-img-link">
              <img src="${imgSrc}" class="product-card-img" alt="${product.title}" loading="lazy">
            </a>
            <div class="product-card-info">
              <span class="product-card-vendor">${product.vendor}</span>
              <h3 class="product-card-title"><a href="${product.url}">${product.title}</a></h3>
              <div class="product-card-price-wrapper">
                <span class="product-card-price">${formatMoney(product.price)}</span>
              </div>
              <div class="product-card-actions">
                <button class="btn btn-primary product-card-btn" onclick="if(window.themeSettings && window.themeSettings.disablePurchaseActions){ trackAndShowOutOfStock('add_to_cart', '${product.variants[0].id}', '${product.title.replace(/'/g, "\\'")}'); } else { quickAddProduct(${product.variants[0].id}); }">Quick Add</button>
              </div>
            </div>
          </div>
        `;
      }
    } catch (e) {
      console.error('Failed to fetch recently viewed product', e);
    }
  }

  if (productCardsHTML) {
    const grid = container.querySelector('.product-grid');
    if (grid) grid.innerHTML = productCardsHTML;
  } else {
    container.closest('section').style.display = 'none';
  }
}

/* ==========================================================================
   10. Cookie Consent Bar
   ========================================================================== */
function initCookieConsent() {
  const consentBar = document.querySelector('.cookie-consent-bar');
  const acceptBtn = document.querySelector('.cookie-consent-btn');

  if (!consentBar || !acceptBtn) return;

  const cookieAccepted = localStorage.getItem('snack_cookies_accepted');

  if (!cookieAccepted) {
    setTimeout(() => {
      consentBar.classList.add('active');
    }, 2000);
  }

  acceptBtn.addEventListener('click', () => {
    localStorage.setItem('snack_cookies_accepted', 'true');
    consentBar.classList.remove('active');
  });
}

/* ==========================================================================
   11. FAQ Accordion Toggle
   ========================================================================== */
function initFAQAccordion() {
  const headers = document.querySelectorAll('.faq-header');
  if (headers.length === 0) return;

  headers.forEach(header => {
    header.addEventListener('click', function() {
      const item = this.closest('.faq-item');
      if (!item) return;

      const isActive = item.classList.contains('active');

      // Close other active FAQ items
      document.querySelectorAll('.faq-item.active').forEach(activeItem => {
        if (activeItem !== item) {
          activeItem.classList.remove('active');
        }
      });

      if (isActive) {
        item.classList.remove('active');
      } else {
        item.classList.add('active');
      }
    });
  });
}

/* ==========================================================================
   12. Text Scramble Effect
   ========================================================================== */
class TextScramble {
  constructor(el) {
    this.el = el;
    this.chars = '!<>-_\\/[]{}—=+*^?#________';
    this.update = this.update.bind(this);
  }
  setText(newText) {
    const oldText = this.el.innerText;
    const length = Math.max(oldText.length, newText.length);
    const promise = new Promise((resolve) => this.resolve = resolve);
    this.queue = [];
    for (let i = 0; i < length; i++) {
      const from = oldText[i] || '';
      const to = newText[i] || '';
      const start = Math.floor(Math.random() * 40);
      const end = start + Math.floor(Math.random() * 40);
      this.queue.push({ from, to, start, end });
    }
    cancelAnimationFrame(this.frameRequest);
    this.frame = 0;
    this.update();
    return promise;
  }
  update() {
    let output = '';
    let complete = 0;
    for (let i = 0, n = this.queue.length; i < n; i++) {
      let { from, to, start, end, char } = this.queue[i];
      if (this.frame >= end) {
        complete++;
        output += to;
      } else if (this.frame >= start) {
        if (!char || Math.random() < 0.28) {
          char = this.randomChar();
          this.queue[i].char = char;
        }
        output += `<span class="scramble-dud" style="opacity:0.6; color:var(--color-accent);">${char}</span>`;
      } else {
        output += from;
      }
    }
    this.el.innerHTML = output;
    if (complete === this.queue.length) {
      this.resolve();
    } else {
      this.frameRequest = requestAnimationFrame(this.update);
      this.frame++;
    }
  }
  randomChar() {
    return this.chars[Math.floor(Math.random() * this.chars.length)];
  }
}

function initTextScramble() {
  const elements = document.querySelectorAll('.js-scramble');
  elements.forEach(el => {
    const fx = new TextScramble(el);
    const text = el.getAttribute('data-scramble-text') || el.innerText;
    const originalHtml = el.innerHTML;
    
    // Set initial text to random characters to show scrambler immediately on load
    let initialScramble = '';
    for(let i=0; i<text.length; i++) {
      initialScramble += text[i] === ' ' ? ' ' : fx.randomChar();
    }
    el.innerHTML = initialScramble;

    setTimeout(() => {
      fx.setText(text).then(() => {
        el.innerHTML = originalHtml;
      });
    }, 300);
  });
}

/* ==========================================================================
   13. Search Wildcard
   ========================================================================== */
function initSearchWildcard() {
  document.body.addEventListener('submit', (e) => {
    const form = e.target;
    if (form.action && form.action.includes('/search')) {
      const qInput = form.querySelector('input[name="q"]');
      if (qInput && qInput.value.trim() && !qInput.value.endsWith('*')) {
        qInput.value = qInput.value.trim() + '*';
      }
    }
  });
}

